import {Button} from '@hm/fundamental'
import {mdiPlus} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {ShutdownStatus, ShutdownType} from '@refra/modules/common/enums'
import {useRefraModal, useShutdowns} from '@refra/modules/common/providers'
import type {NewShutdown} from '@refra/modules/common/types'
import {NewShutdownModal} from '@refra/modules/refra-static-parts/components/StaticPartDetail/ShutdownHistoryCard/ShutdownHistoryCardHeader/ShutdownHistoryActions/NewShutdownModal'

export const ShutdownHistoryActions: React.FC = () => {
  const {t} = useTranslation()

  const {newShutdown, setNewShutdown} = useShutdowns()
  const {openModal} = useRefraModal()

  const isUserAddingNewShutdown = newShutdown !== null

  const onAddNewShutdown = () => {
    const newKilnShutdown: NewShutdown = {
      id: undefined,
      name: '',
      shutdownType: ShutdownType.RegularReplacement,
      shutdownStatus: ShutdownStatus.Draft,
      interventionDate: '',
      feedingDate: undefined
    }
    setNewShutdown(newKilnShutdown)
    openModal(<NewShutdownModal />)
  }

  return (
    <div data-cy="shutdown_history_card_actions">
      <Button
        icon={mdiPlus}
        variant="tertiary"
        onClick={onAddNewShutdown}
        data-cy="shutdown_history_card_create_button"
        disabled={isUserAddingNewShutdown}
      >
        {t('refraPlanning.kilnShutdown.newShutdown')}
      </Button>
    </div>
  )
}
